import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { User } from 'lucide-react';
import QRCode from 'react-qr-code';
import { Navigate } from 'react-router-dom';

const ClubView: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-black border-t-transparent rounded-full"></div></div>;
  }

  if (!user) {
     return <Navigate to="/login" replace />;
  }

  // Generate a unique value for the QR code
  const qrValue = user ? `4hvnsk8://member/${user.uid}` : 'https://4hvnsk8.com/join';

  return (
    <div className="max-w-md mx-auto pt-32 pb-12 px-4 min-h-[60vh] flex flex-col justify-center">
      <h1 className="font-display text-2xl font-normal tracking-[0.3em] uppercase text-center mb-8">KEEPER</h1>
      <div className="bg-gradient-to-br from-gray-900 to-black text-white p-8 rounded-xl shadow-2xl relative overflow-hidden aspect-[1.58/1] flex flex-col justify-between group transition-transform hover:scale-[1.02] duration-500">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] mix-blend-overlay"></div>

        {/* Watermark Center Logo */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <img
               src="/assets/logo/4HVNSK8-logo-black.svg"
               alt="Watermark"
               className="w-[80%] h-[80%] object-contain opacity-[0.15] rotate-[-15deg] select-none invert"
            />
        </div>

        {/* Shine Effect */}
        <div className="absolute inset-0 bg-gradient-to-tr from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

        <div className="relative z-10 h-full flex flex-col justify-between">
          <div className="flex justify-between items-start">
            <div>
                <h2 className="font-heading text-2xl tracking-[0.2em] font-black">4HVNSK8</h2>
            </div>
            <User size={24} className="opacity-50" />
          </div>

          <div className="flex justify-between items-end">
            <div className="space-y-1">
              <div>
                 <p className="font-mono text-[10px] uppercase tracking-wider mb-1 opacity-70">Member ID</p>
                 <p className="font-mono text-xs tracking-widest opacity-90">
                    {user?.uid ? user.uid.substring(0, 12).toUpperCase().match(/.{1,4}/g)?.join(' ') : '0000 0000 0000'}
                 </p>
              </div>
              <div className="pt-4">
                 <p className="font-heading text-lg tracking-widest uppercase truncate max-w-[180px]">
                    {user?.displayName || user?.email?.split('@')[0] || 'GUEST MEMBER'}
                 </p>
              </div>
            </div>

            <div className="bg-white p-2 rounded-lg shadow-lg">
               <div style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%" }}>
                <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={qrValue}
                    viewBox={`0 0 256 256`}
                />
               </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ClubView;
